import React from "react";
import Custombutton from "../../../utils/Custombutton";
import ParticlesAnimation from "../../../utils/ParticlesAnimation2";

const Teams = () => {
  return (
    <div id="team" className="position-relative">
      <div class="night " style={{ backgroundImage: "none" }}>
        <ParticlesAnimation />
      </div>
      <div className="news teams " style={{ background: "none" }}>

        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="d-flex flex-md-nowrap align-items-end justify-content-between flex-wrap">
                <h1>
                  {" "}
                  <div className="position-relative">
                    <h2 className="bordered-text">Our </h2>
                    <h1 className=" position-relative" style={{ zIndex: "11" }}>Team </h1>
                  </div>
                </h1>
                <Custombutton
                  className={
                    "btn-outline gradient-outline gradient-text mt-5 mt-md-0 position-relative"
                  }
                  label={"view More"}
                />
              </div>
            </div>
            <div className="row equal-height ms-0">

              <div className="col-xl-8 mb-4">
                <div className=" first  h-100">
                  <div className="teams-card  h-100">
                    <div className="row align-items-center  h-100">
                      <div className="col-lg-6">
                        <img
                          className="w-100 asad"
                          src="/assets/images/asad.png"
                          alt="asad"
                        />
                      </div>
                      <div className="col-lg-6">
                        <div className="p-5">

                          <h3>asad</h3>
                          <span>CEO</span>
                          < br />
                          < br />
                          <p className="" style={{ textWrap: "balance" }}>
                            With 15 years of experience in enterprise IT infrastructure, security, and networking, Asad has a strong foundation in the technological aspects critical to a tech company's growth. His foray into the crypto world since 2021 has equipped him with valuable insights into blockchain technology, making him an adept leader for Cosmic Network.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4  d-flex flex-column">
                <div className="teams-card second d-flex flex-column mb-4   justify-content-center">
                  <h4>Mahad</h4>
                  <span>CTO</span>
                  < br />
                  <h6>
                    Mahad's five-year tenure in the cryptocurrency sector, working on diverse projects, positions him as a key figure in overseeing Cosmic Network's technological direction, ensuring that the company remains at the forefront of blockchain innovation.
                  </h6>
                </div>

                <div className="teams-card second  d-flex flex-column   justify-content-center">
                  <h4>xA</h4>
                  <span>Lead Blockchain Developer</span>
                  < br />
                  <h6>
                    xA, Cosmic Network's Lead Blockchain Developer, uniquely combines expertise in blockchain, web development, and artificial intelligence, underscored by a dedication to AI ethics.
                  </h6>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  );
};

export default Teams;
